module.exports = __webpack_public_path__ + "5-stars-766e6415.svg";